import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { isOurApiUrl } from '../utils/vanity-url.util';

/**
 * Sends the current portal hostname so the API can resolve vanity Organization context
 * when requests are routed through APIM (where req.Url.Host is the API domain).
 */
@Injectable()
export class BrandDomainInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (typeof window === 'undefined') {
      return next.handle(req);
    }

    const isOurApi = isOurApiUrl(req.url);

    if (!isOurApi) {
      return next.handle(req);
    }

    const cloned = req.clone({
      setHeaders: {
        'X-Brand-Domain': window.location.hostname,
      },
    });

    return next.handle(cloned);
  }
}
